module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABC0lEQVR4AbXSAaTCQBzH8TCE4WEYwjCEIcDDEAMEABiGAeAB4GF4gIcQIIQAIQQIEAACBBhCgEMYhvX9czHn2gn9+MC/f787bqOPp+u6MTIUWgrvnYIASzQwo1DBd5VMUUOyRY4EERbYQXJG+KokxBU3LAYOy3DXZb5tYYMGiTEvEFhmksp2mxb/lgNqzC3zAxS8/jCHJHmjqIQk7Q8rdOayo2gGSWEWSXzLH47YITTmE0jKwWsa39UaCj/weq8nyfrLESR/A8/+jdPzMF3eYGwu7tFiNnJEdtBiafsxhsIFk4GSOW6oEbxaSqG0X8R6/oUMK0iumLquHWMPW1pszBd0FUYoUWm5LvhsHkGY4hnoooTyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/time.png
// module id = 231
// module chunks = 0